import { Component, OnInit, inject } from '@angular/core';
import { MeService } from 'app/core/services/me.service';
import { ClientsService } from 'app/core/services/clients.service';
import { AuthenticationService } from 'app/core/services/authentication.service';
import { Client } from 'app/core/models/client.model';
import { Observable, of, iif } from 'rxjs';
import { DatePipe } from '@angular/common';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { ClientInfoCardComponent } from '../../components/client-info-card/client-info-card.component';
import { ClientProgramMetricsComponent } from '../../components/client-program-metrics/client-program-metrics.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-client-portal-metrics',
  templateUrl: './client-portal-metrics.component.html',
  imports: [ClientInfoCardComponent, ClientProgramMetricsComponent, MatProgressSpinner, DatePipe]
})
export class ClientPortalMetricsComponent implements OnInit {
  private clientsService = inject(ClientsService);
  private meService = inject(MeService);
  private authService = inject(AuthenticationService);

  loading = true;
  client: Client;

  ngOnInit() {
    this.loadEverything();
  }

  private loadEverything() {
    iif(
      this.isViewingAsClient(this.authService.viewingAsClient),
      this.clientsService.get(this.authService.viewingAsClient?.id),
      this.reloadUserAndLoadClient()
    ).pipe(
      catchError(error => {
        console.error('Error:', error);
        return of(null);
      }),
      finalize(() => this.loading = false)
    ).subscribe(client => {
      if (client) { this.client = client; }
    });
  }

  private isViewingAsClient(client: Client) {
    return () => client !== null;
  }

  private reloadUserAndLoadClient(): Observable<Client> {
    return this.meService.get().pipe(
      switchMap(user => {
        const clientId = user.defaultAllowedClientId || user.availableClients[0].id;
        return this.clientsService.get(clientId);
      })
    );
  }
}
